import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    .line-code {
        background-color: #242424;
        color: #FFFFFF;
        padding: 2px 6px;
        margin-right: 12px;
    }
`;
